import { render, staticRenderFns } from "./GroupHeader.vue?vue&type=template&id=c34287fa&scoped=true"
import script from "./GroupHeader.vue?vue&type=script&lang=js"
export * from "./GroupHeader.vue?vue&type=script&lang=js"
import style0 from "./GroupHeader.vue?vue&type=style&index=0&id=c34287fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c34287fa",
  null
  
)

export default component.exports